import { IProject } from '@photosi/expo-photosi-sdk/build/Project';
import { IImageEditor } from '@photosi/expo-photosi-sdk/build/ImageEditor';
import amplitude from '../../_shared/amplitude';
import { AnalyticsEvents } from '../../_shared/analyticsEvents';
import { PickedImage } from '@photosi/expo-photosi-sdk/build/ImageLibrary';
import { filesToPickedImages, TFilesToPickedImagesOptions } from '../../_shared/utils/filesToPickedImages';
import { ImageTypes } from 'src/_shared/image-picker/ImagePicker.constants';

export const sdkProjects: Map<string, IProject> = new Map<string, IProject>();
export const sdkEditors: Map<string, IImageEditor> = new Map<string, IImageEditor>();

type pickImagesOptions = {
  allowsMultipleSelection?: boolean;
  newRoute?: boolean;
} & TFilesToPickedImagesOptions;

export const pickImages = async ({
  allowsMultipleSelection = false,
  newRoute = false,
  ...filesToPickedImagesOptions
}: pickImagesOptions): Promise<PickedImage[]> => {
  let files: PickedImage[] = [];

  const input = document.createElement('input');
  input.setAttribute('data-testid', 'input-web-picker');
  input.setAttribute('type', 'file');
  input.setAttribute('multiple', 'true');
  input.setAttribute('accept', ImageTypes.join(','));
  document.body.appendChild(input);

  return new Promise<PickedImage[]>((resolve, reject) => {
    input.addEventListener('cancel', () => {
      amplitude.trackEvent(AnalyticsEvents.dynamicPicker.closeClick);
      resolve([]);
    });
    input.addEventListener('change', async () => {
      try {
        if (input.files && input.files.length > 0) {
          files = await filesToPickedImages(Object.values(input.files), filesToPickedImagesOptions, newRoute);
          resolve(files);
        } else {
          throw new Error('No files selected');
        }
      } catch (error) {
        reject(error);
      }
    });

    // open the file picker
    input.click();
  })
    .then((res: PickedImage[]) => {
      document.body.removeChild(input);
      return res;
    })
    .catch(error => {
      document.body.removeChild(input);
      throw new Error(error);
    });
};
